import { Controller } from "@hotwired/stimulus"
import tippy from 'tippy.js'

export default class extends Controller {
  static targets = ["calendar"]
  static values = { 
    batchId: Number,
    persistedColor: String,
    persistedText: String
  }

  connect() {
    if (this.hasCalendarTarget) {
      this.initializeCalendar()
      this.loadAppointments()
    }
    this.tooltipInstance = null
  }

  disconnect() {
    if (this.calendar) {
      this.calendar.destroy()
    }
  }

  initializeCalendar() {
    const calendarHeight = this.calendarTarget.clientHeight || 450
    
    this.calendar = new FullCalendar.Calendar(this.calendarTarget, {
      initialView: 'dayGridMonth',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek'
      },
      locale: 'pt-br',
      selectable: false,
      droppable: false,
      editable: false,
      // eventClick: this.handleEventClick.bind(this),
      eventMouseEnter: this.handleEventMouseEnter.bind(this),
      eventMouseLeave: this.handleEventMouseLeave.bind(this),
      eventDidMount: this.handleEventDidMount.bind(this),
      height: calendarHeight,
      scrollTime: '08:00:00',
      scrollTimeReset: false,
      buttonText: {
        today: 'Hoje',
        month: 'Mês',
        week: 'Semana',
        day: 'Dia'
      }
    })
    this.calendar.render()
  }

  async loadAppointments() {
    try {
      const response = await fetch(`/admin/batches/${this.batchIdValue}/appointments.json`)
      const appointments = await response.json()
      
      appointments.forEach(appointment => {
        this.calendar.addEvent({
          id: appointment.id,
          title: appointment.title,
          start: appointment.start,
          end: appointment.end,
          backgroundColor: this.persistedColorValue,
          borderColor: this.persistedColorValue,
          textColor: this.persistedTextValue,
          extendedProps: {
            type: 'appointment',
            extras: appointment.extras
          }
        })
      })
    } catch (error) {
      console.error('Erro ao carregar appointments:', error)
    }
  }

  // handleEventClick(clickInfo) {
  //   const event = clickInfo.event
  //   const appointmentId = event.id
  //
  //   if (!appointmentId) {
  //     return
  //   }
  //
  //   console.log('Appointment clicked:', appointmentId)
  // }

  handleEventDidMount(info) {
    this.addEventClass(info.event.el, 'fc-event-persisted')
  }

  handleEventMouseEnter(info) {
    const event = info.event
    const tooltipContent = this.buildTooltipContent(event)
    
    this.tooltipInstance = tippy(info.el, {
      content: tooltipContent,
      allowHTML: true,
      animation: 'scale',
      theme: 'calendar-tooltip',
      arrow: true,
      placement: 'top',
      hideOnClick: false,
      trigger: 'manual',
      duration: [100, 0],
      delay: [300, 0]
    })
    
    this.tooltipInstance.show()
  }

  handleEventMouseLeave() {
    if (this.tooltipInstance) {
      this.tooltipInstance.destroy()
      this.tooltipInstance = null
    }
  }

  buildTooltipContent(event) {
    const startDate = new Date(event.start)
    const endDate = new Date(event.end)
    
    const formatDate = (date) => {
      return date.toLocaleDateString('pt-BR', { 
        weekday: 'long',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    }
    
    const formatTime = (date) => {
      return date.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      })
    }

    const title = event.title || 'Aula'
    
    return `
      <div class="p-3 text-sm">
        <div class="font-semibold text-slate-900 mb-2 text-base">${title}</div>
        <div class="text-slate-700 mb-1">
          <strong>Data:</strong> ${formatDate(startDate)}
        </div>
        <div class="text-slate-700 mb-1">
          <strong>Horário:</strong> ${formatTime(startDate)} - ${formatTime(endDate)}
        </div>
      </div>
    `
  }

  addEventClass(eventEl, className) {
    if (eventEl && !eventEl.classList.contains(className)) {
      eventEl.classList.add(className)
    }
  }

  removeEventClass(eventEl, className) {
    if (eventEl && eventEl.classList.contains(className)) {
      eventEl.classList.remove(className)
    }
  }
}
